import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { CursorType } from "utils/types"

export type InfoType = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;
    parent_type: string;
    parent_uuid: string;
    data: string;
    datatype: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: InfoType) => void;
};

// Domain object Info
export class Info implements InfoType {
    key = "";
    uuid = "";
    identity = "";

    associated_type = "";
    associated_uuid = "";
    parent_type = "";
    parent_uuid = "";
    data = "";
    datatype = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: InfoType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: InfoType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class InfoStore extends BaseStore<InfoType, Info> {


    async fetchInfo(uuid: string) {
        // Autogenerated
        const response = await api_get(`/info?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;

        }
        return null;
    }


    async fetchListByParent(identity_uuid: string,
        parent_type: string, parent_uuid: string,
        cursor?: CursorType): Promise<InfoType[]>  {
            var url = '/info/list/by-parent';
        const params = {
            identity: identity_uuid,
            parent_type,
            parent_uuid,
            cursor: cursor || ''
        }

        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByParent(identity_uuid, parent_type, parent_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but InfoStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    modelConstructor() {
        return Info;
    }

}
